export default "__VITE_ASSET__WmwjscU5__"